import { createContext, useContext, type ReactNode } from "react";
import type { ProviderOutletContext } from "./ProviderOutletContext";

export type ProviderWorkspaceValue = Omit<
  ProviderOutletContext,
  | "operationsVersion"
  | "createBookingRequestToken"
  | "checkoutSessionId"
  | "venuePanel"
  | "setVenuePanel"
  | "venueRemovalNote"
  | "setVenueRemovalNote"
  | "venueRemovalError"
  | "setVenueRemovalError"
>;

const ProviderWorkspaceContext = createContext<ProviderWorkspaceValue | null>(null);

export function ProviderWorkspaceProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: ProviderWorkspaceValue;
}) {
  return (
    <ProviderWorkspaceContext.Provider value={value}>
      {children}
    </ProviderWorkspaceContext.Provider>
  );
}

export function useProviderWorkspace(): ProviderWorkspaceValue {
  const context = useContext(ProviderWorkspaceContext);
  if (!context) {
    throw new Error(
      "useProviderWorkspace must be used within a ProviderWorkspaceProvider",
    );
  }
  return context;
}
